export const environment = {
    production: false,
    idmUrl: 'https://idm.qa.zsservices.com/CDS/IdentityManager/app/Web/Login.aspx?ReturnUrl=https://test.cds.zsservices.com/projects',
    organization: 'MERCK',
    accessRequestUrl : '',
    mailDl :''
  
  };
  